// lib/mock/orders.ts
import type { Order } from "@/types";

export const MOCK_ORDERS: Order[] = [
  {
    id: "KH-1403-45821",
    customerName: "علی محمدی",
    customerPhone: "09121234567",
    amount: 1566530,
    status: "shipping",
    itemsCount: 3,
    createdAt: Date.now() - 3 * 3600000,
  },
  {
    id: "KH-1403-45830",
    customerName: "سارا احمدی",
    customerPhone: "09129876543",
    amount: 537150,
    status: "pending",
    itemsCount: 1,
    createdAt: Date.now() - 30 * 60000,
  },
  {
    id: "KH-1403-45790",
    customerName: "رضا کریمی",
    customerPhone: "09135551234",
    amount: 714710,
    status: "confirmed",
    itemsCount: 2,
    createdAt: Date.now() - 86400000,
  },
  {
    id: "KH-1403-45680",
    customerName: "مریم صادقی",
    customerPhone: "09147778899",
    amount: 525150,
    status: "delivered",
    itemsCount: 2,
    createdAt: Date.now() - 2 * 86400000,
  },
  {
    id: "KH-1403-45510",
    customerName: "حسین بیات",
    customerPhone: "09112345678",
    amount: 171600,
    status: "canceled",
    itemsCount: 1,
    createdAt: Date.now() - 3 * 86400000,
  },
  {
    id: "KH-1403-45422",
    customerName: "نیلوفر رضایی",
    customerPhone: "09128887766",
    amount: 2340000,
    status: "delivered",
    itemsCount: 5,
    createdAt: Date.now() - 4 * 86400000,
  },
  {
    id: "KH-1403-45311",
    customerName: "امیر حسینی",
    customerPhone: "09136664422",
    amount: 890500,
    status: "shipping",
    itemsCount: 2,
    createdAt: Date.now() - 5 * 86400000,
  },
  {
    id: "KH-1403-45208",
    customerName: "فاطمه نوری",
    customerPhone: "09144443322",
    amount: 1250000,
    status: "pending",
    itemsCount: 4,
    createdAt: Date.now() - 6 * 86400000,
  },
];